
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLineOfPositionIec as ObiLineOfPositionIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-line-of-position-iec.js';
 
 
 

 
 export const ObiLineOfPositionIec = createComponent({
   react: React,
   tagName: 'obi-line-of-position-iec',
   elementClass: ObiLineOfPositionIecElement,
   events: {
     
   }
  });
 
 